import { Action, ActionReducer } from '@ngrx/store';
import { EntryCycleIdAction, EntryCycleIdActionType } from '../../actionstypes/selected-id/entry-cycle-id.actiontype';

const initialState = -1;

const entryCycleIdReducer = (state = initialState, action: EntryCycleIdActionType): number => {
  switch (action.type) {
    case EntryCycleIdAction.Init:
      return action.entryCycleId;

    case EntryCycleIdAction.Set:
      return action.entryCycleId;

    case EntryCycleIdAction.Reset:
      return -1;

    default:
      return state;
  }
};

export default entryCycleIdReducer as ActionReducer<number, Action<string>>;
